<template>
  <div class="Details">
    <div class="bigImg">
        <img class="topimg" src="../../static/wap/index/top.png" alt="" />
      <div class="title">细致交易</div>
      <div class="title">风险防控</div>
      <div class="titles">专业黄金，优质服务</div>
      <img class="download"  @click="toLoad" src="../../static/wap/index/download.png" alt="" />
        <!-- <div class="topbox">
        <div class="flex boxs"  >
          <div class="left flex1">A</div>
          <div class="right">
            <span class="txts">伦敦金</span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ golds||0 }}</span>
              <span class="txt" style="color: #fa2314">{{ priceRange.value||0 }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class=" left flex1 " style="background: #A915AC;" >B</div>
          <div class="right">
            <span class="txts">伦敦银</span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ sliver||0}}</span>
              <span class="txt" style="color: #fa2314">{{ priceRange1.value||0 }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class=" left flex1 " style="background: #15AC36">C</div>
          <div class="right">
            <span class="txts">美国原油 <span style="color: #fa2314;">(参考)</span></span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ usd }}</span>
              <span class="txt" style="color: #fa2314">{{ priceRange2.value||0 }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class="left flex1">D</div>
          <div class="right">
            <span class="txts">纳斯达克指数 <span style="color: #fa2314;">(参考)</span></span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ nas}}</span>
              <span class="txt" style="color: #fa2314">{{ priceRange3.value||0 }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class="left flex1">E</div>
          <div class="right">
            <span class="txts">恒生指数 <span style="color: #fa2314;">(参考)</span></span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ hk50 }}</span>
              <span class="txt" style="color: #fa2314">{{ priceRange4.value||0 }}</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="detailTable">
        <el-table
        :data="tableData"
        :span-method="arraySpanMethod"
        stripe
        border
        style="width: 1130px;margin: 0 auto;fontSize:12px;"
        :header-cell-style="{textAlign: 'center',background:'rgb(250, 35, 20)',color:'#fff',border:'none'}"
        :header-row-style="{height:'46px'}"
        :cell-style="{ textAlign: 'center',borderRight:'none'  }">
        <el-table-column
          prop="date"
          label=""
          min-width="20%">
        </el-table-column>
        <el-table-column
          prop="name"
          label="伦敦金"
          min-width="40%">
        </el-table-column>
        <el-table-column
          prop="address"
          label="伦敦银"
          min-width="40%">
        </el-table-column>
      </el-table>
      
    </div>
  </div>
</template>
<script>
import NP from 'number-precision';
import eventBusMitter from '../../utils/eventbus'

  export default {
    name: 'Details',
    metaInfo: {  
      title: '红狮金业,贵金属投资,现货黄金白银交易,伦敦金伦敦银开户,黄金交易投资',
      meta: [
        { name: 'keywords', content: '红狮金业,红狮启富,黄金交易平台,贵金属交易,贵金属投资,贵金属平台,现货黄金开户,正规靠谱外汇交易,正规网上交易平台' },
        { name: 'description', content: '红狮金业是专业值得信赖的国际投资交易平台,专注于为客户提供24小时全球金融产品在线交易,包括现货黄金、现货白银、贵金属等产品的开户、投资交易服务。' }
      ]  
    },      data () {
      return {
        control: 1,
        details:[],
        
          tableData: [{
          date: '合约单位',
          name: '100',
          address: '5000'
        }, {
          date: '货币单位',
          name: 'USD',
          address: 'USD'
        },{
          date: '报价小数点',
          name: '2',
          address: '3'
        }, {
          date: '点差',
          name: '根据市况浮动',
          address: '根据市况浮动'
        }, {
          date: '单笔交易手数',
          name: '0.01手～20.00手',
          address: '0.01手～20.00手'
        },{
          date: '手数差值',
          name: '0.01手',
          address: '0.01手'
        }, {
          date: '最小挂单距离',
          name: '100点(根据市况浮动)',
          address: '100点(根据市况浮动)'
        },{
          date: '初始保证金',
          name: '合约价值*0.5%',
          address: '合约价值*0.5%'
        }, {
          date: '假期保证金',
          name: '双倍',
          address: '双倍'
        }, {
          date: '锁仓保证金',
          name: '按所需保证金较多的订单收取',
          address: '按所需保证金较多的订单收取'
        },{
          date: '库存费',
          name: '根据市况浮动',
          address: '根据市况浮动'
        },{
          date: '三天利息日',
          name: '周四',
          address: '周四'
        }, {
          date: '交易时间GMT+8',
          name: '周一：06:00-24:00周二至周五：00:00-04:55 / 06:00-24:00周六：00:00-04:45',
          address: ''
        }, {
          date: '结算时间',
          name: '夏今：5点为结筤时间 \n 冬令：6点为结算时间',
          address: '夏今：5点为结筤时间 \n 冬令：6点为结算时间'
        }],
         topData: [
        {
          name: "A",
          title: "市场01",
          title1: "45612.25 CNY",
          title2: "+ 0.01%",
        },
        {
          name: "B",
          title: "市场01",
          title1: "45612.25 CNY",
          title2: "+ 0.01%",
        },
        {
          name: "C",
          title: "市场01",
          title1: "45612.25 CNY",
          title2: "+ 0.01%",
        },
      ],
      screenWidth:null,
      
      goldList:[],
      baseData:{}
      }
    },
    created(){
      eventBusMitter.emit('eventtab', { key: false })

      this.$emit('controlShow', false);
     
     this.baseData=this.$parent.sblsBaseData
      
    },
    mounted(){
       
    
    setTimeout(() => {
      
    this.goldList= this.getData('GOLD')
    this.tableData[12].name=this.goldList.join('')
        

    }, 1000);
      this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
        console.log('屏幕宽度',this.screenWidth)
      })()
    };
    },
    methods: {
     
  toLoad(){
            eventBusMitter.emit('eventNas', {key:4})

        this.$router.push({
              name: "Appdownloadwap",
               query: {
                showTop:true
              }
            });
      },
  selectedCenter(attr){
        if(attr == 1){
          this.control = attr;
          this.details = this.detailsOne;
        }else{
          this.control = attr;
          this.details = this.detailsTwo;
        }
      },
  //合并单元格
     arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      console.log(rowIndex,columnIndex)
        
         if (rowIndex % 12 === 0&&rowIndex!=0) {
          if (columnIndex === 1) {
            return [1, 2];
          } 
        }
      },
  //表格颜色变化
    
    //获取交易时间
      getData(type){
        
        const weekArr = ['日', '一', '二', '三', '四', '五', '六'];
        // 交易时间
        let sessions = this.baseData[type].sessionsList;
        if (!sessions || sessions.length === 0) {
           return '';
         }
         let dayList = [];
        let timeResult = [];
  sessions.forEach((item) => {
    if (item.type === 1 && item.close !== 0) {
      let dateList = '';
      let startHour = NP.divide(Number(item.open), 60);
      console.log('startHour', startHour)
      let endHour = NP.divide(Number(item.close), 60);
      if (startHour > 24) {
        startHour = NP.minus(Number(startHour), 24);
      }
      console.log('endHour', endHour)
      if (endHour > 24) {
        endHour = NP.minus(Number(endHour), 24);
      }
      let start = this.time(Math.trunc(startHour), item.open % 60);
      let end = this.time(Math.trunc(endHour), item.close % 60);
      if (end.startsWith('00:')) {
        end = end.replaceFirst('00:', '24:');
      }

      let times = start + '-' + end;
      if (dayList.indexOf(item.day) > -1) {
        dateList= timeResult[item.day];
      } else {
        dayList.push(item.day);
      }
      dateList = dateList + ' ' + times;
      timeResult[item.day] = dateList;
    }
  });
  timeResult.forEach((item, i) => {
    if(i === 0) {
      timeResult[i] ='周日: ' + item+'\n';
      } else if (i === 1) {
      timeResult[i] = '周一: ' + item+'\n';
      } else if (i === 2) {
      timeResult[i] = '周二: ' + item+'\n';
      } else if (i === 3) {
      timeResult[i] = '周三: ' + item+'\n';
      } else if (i === 4) {
      timeResult[i] = '周四: ' + item+'\n';
      } else if (i === 5) {
      timeResult[i] = '周五: ' + item+'\n';
      } else {
      timeResult[i] = '周六: ' + item+'\n';
      }
       });
       timeResult = timeResult.filter(t => t)
      return timeResult
      },
       time (hour, min) {
        return (
            (hour > 9 ? hour : '0' + hour) +
           ':' +
          (min > 9 ? min : '0' + min) +
          ':' +
           '00'
        );
      },
    },

    watch: {
    screenWidth(n) {
      console.log('屏幕发生了变化888',n)
     
    },
    
    },
    computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.scrollTop;
      console.log(screenHeight);
      if (screenHeight > 415) {
        return "550px";
      } else {
        return "250px";
      }
    },
    golds(){
      return this.$parent.goldData
    },
    high(){
      return this.$parent.goldData1
    },

    priceRange(){
    let value=(this.golds-this.high).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.high? ((Math.abs(value) * 100) / this.high).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     hk50(){
      return this.$parent.hk50
    },
    hk501(){
      return this.$parent.hk501
    },

    priceRange4(){
    let value=(this.hk50-this.hk501).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.hk501? ((Math.abs(value) * 100) / this.hk501).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     nas(){
      return this.$parent.nas
    },
    nas1(){
      return this.$parent.nas1
    },

    priceRange3(){
    let value=(this.nas-this.nas1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.nas1? ((Math.abs(value) * 100) / this.nas1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
    sliver(){
      return this.$parent.sliver
    },
    sliver1(){
      return this.$parent.sliver1
    },

    priceRange1(){
    let value=(this.sliver-this.sliver1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.sliver1? ((Math.abs(value) * 100) / this.sliver1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     usd(){
      return this.$parent.usd
    },
    usd1(){
      return this.$parent.usd1
    },

    priceRange2(){
    let value=(this.usd-this.usd1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.usd1? ((Math.abs(value) * 100) / this.usd1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
   
   
  },

  }
</script>

<style lang="less" scoped>
  .Details{
    // width: 7.50rem;
    width: 100%;

 

     .bigImg {
    width: 100%;
      height: 750px;
      background: url('../../static/wap/detail/topbg.png') no-repeat;
      background-size: 100% 100%;
    background-size: cover;
    box-sizing: border-box;
    //   overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .title {
      font-size: 58px;
      line-height: 77px;
      color: #fff;
      font-weight: 700;
    }
    .titles {
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      margin: 6px 0 24px 0;
    }
    .topimg {
      width: 110px;
      height: 30px;
      margin: 28px 0 6px 0;
    }
    .download {
      width: 180px;
      height: 34px;
    }
    .flex {
      display: flex;
      align-items: center;
    }
    .flex1 {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    //市场
     .topbox {
      width: 86%;
      height: 40px;
      overflow: scroll;
      display: flex;
      position: absolute;
      left: 1rem;
      bottom: -4%;
      z-index: 10;
      white-space: nowrap;
      .boxs {
        width: 164px;
        height: 40px;
        background: #fff;
        color: #fff;
        margin-right: 10px;
        padding: 10px 12px;
        box-sizing: border-box;
        .left {
          background: #1552ac;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          font-size: 14px;
          line-height: 19px;
          margin-right: 7px
        }
        .right {
          font-size: 12px;
          line-height: 17px;
          .txt {
            font-size: 10px;
            color: #93939f;
            width: 36px;
          }
          .txts{
            color: #0F0F11;
            font-size: 12px;
            line-height: 17px;
            font-weight: 600;

          }
          .cont {
            display: flex;
            // flex-direction: column;
          }
        }
      }
    }
  }
    .detailTable{
      width: 100%;
      box-sizing: border-box;
      padding: 48px 0.5rem;
      margin: 0 auto;
      background: #f2f2f2;
      /deep/ .el-table__row{
        height: 89px;
      }
      /deep/ .el-table__row--striped{
        height: 80px;
      }
      /deep/ .el-table__row td:nth-child(1){
        font-weight: 600 !important;
      }
       /deep/ .el-table__row td:nth-child(2){
      
        color: #D18A1F !important;
      }
      /deep/ .el-table__row td:nth-child(3){
      
        color: #93939F !important;
      }
      /deep/ .el-table_7_column_20 {
       
        color: #FA2314 !important;

        

      }

      /deep/ .el-table .cell {
        white-space: pre-line;
      }
      ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td{
        background: #fff;
      }
      ::v-deep .el-table__header-wrapper{
         border-collapse: collapse;
         border: none;
      }
    
    }
  }
</style>